import ErrorDialog from "./ErrorDialog";

export default ErrorDialog;
